const angular = require('angular')
const mainCtrl = require('./mainCtrl')
const sideMenuCtrl = require('./sideMenuCtrl')
const secAuthLoginCtrl = require('./secAuthLoginCtrl')
const loginRemindingCtrl = require('./loginRemindingCtrl')
const introCtrl = require('./introCtrl')
require('js/services/module')

/* Controllers */
module.exports = angular.module('hxphone.controllers', ['hxphone.services'])
/* 主逻辑 */
  .controller('MainCtrl', mainCtrl)

// 侧边栏
  .controller('sideMenuCtrl', sideMenuCtrl)

  .controller('secAuthLoginCtrl', secAuthLoginCtrl)

/* 登录提醒 */
  .controller('loginRemindingCtrl', loginRemindingCtrl)

/* 出错页面 */
  .controller('introCtrl', introCtrl)



// WEBPACK FOOTER //
// ./src/js/controllers/module.js